import { observer } from 'mobx-react';
import { henshu, useHenshu } from '@strategies/henshu';
import { AutoSizer } from 'react-virtualized';

import Section from '../Section';
import { Callout, Pin } from '../MapIcons/MapIcons';
import { COMAP_URL } from '../../config';

import sunIcon from '../../assets/sun.svg';
import cameraIcon from '../../assets/camera.svg';
import globeIcon from '../../assets/globe.svg';
import usersIcon from '../../assets/users.svg';
import walkPath from '../../assets/walk-path.png';


export default observer(function Welcome() {
    const { bindTo } = useHenshu();

    return (
        <Section name="Welcome" index={0}>
            <henshu.a
                className="button with-arrow"
                href={"#share"}
                {...bindTo('engagement.button')}
            />

            <henshu.richtext className="welcome" {...bindTo('engagement.tagline')} />

            <div className='engagement-animation engage'>
                <Callout term="animation.prompt1"/>
                <Callout term="animation.prompt2"/>
                <Pin className="live" alt={''} icon={sunIcon} term="animation.icon1" />
                <Pin className="work" alt={''} icon={usersIcon} term="animation.icon2" />

                <div className="connected-pins">
                    <AutoSizer>
                        {({ width, height }) => <>
                            <Pin className="walk" alt={''} icon={globeIcon} term="animation.icon3" />
                            <Pin className="entertainment" alt={''} icon={cameraIcon} term="animation.icon4" />
                            <div className="path-wrapper">
                                <img src={walkPath} aria-hidden="true" alt="Animated path" style={{ width, height }} />
                            </div>
                        </>}
                    </AutoSizer>
                </div>
            </div>
        </Section>
    );
});
